import React from "react";
import { Row, Col, Button, Modal, Container, Form } from "react-bootstrap";

import "./EditSupportUsers.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class EditSupportUsers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: {
        id: this.props.ItemList ? this.props.ItemList.id : null,
        lName: this.props.ItemList ? this.props.ItemList.lName : null,
        fName: this.props.ItemList ? this.props.ItemList.fName : null,
        dsgntn: this.props.ItemList ? this.props.ItemList.dsgntn : null,
        email: this.props.ItemList ? this.props.ItemList.email : null,
        mob: this.props.ItemList ? this.props.ItemList.mob : null
      }
    };
    this.submit = this.submit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: {
        ...this.state.value,
        id: nextProps.ItemList.id,
        lName: nextProps.ItemList.lName,
        fName: nextProps.ItemList.fName,
        dsgntn: nextProps.ItemList.dsgntn,
        email: nextProps.ItemList.email,
        mob: nextProps.ItemList.mob
      }
    });
  }

  submit = () => {
    const Data = this.state.value;
    let regexemail = /^\S+@\S+\.\S+$/;
    let regexcode = /^[7-9][0-9]{9}$/;

    // console.log("Data.lName" + Data.dsgntn);
    if (
      Data.lName === "" ||
      Data.fName === "" ||
      Data.dsgntn === "" ||
      Data.email === "" ||
      Data.mob === ""
    ) {
      toast.error("Please fill out this field", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      });
    } else if (!regexemail.test(Data.email) || !regexcode.test(Data.mob)) {
      toast.error("Enter a valid input", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      });
    } else {
      this.props.editSupportUsers(Data);
      this.props.closemodel();
      this.props.resetPage();
    }
  };

  onChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === "lName") {
      this.setState({
        value: { ...this.state.value, lName: value }
      });
    } else if (name === "fName") {
      this.setState({ value: { ...this.state.value, fName: value } });
    } else if (name === "dsgntn") {
      this.setState({ value: { ...this.state.value, dsgntn: value } });
    } else if (name === "email") {
      this.setState({ value: { ...this.state.value, email: value } });
    } else if (name === "mob") {
      this.setState({ value: { ...this.state.value, mob: value } });
    }
  };

  render() {
    return (
      <div>
        <Modal
          show={this.props.editShow}
          size="lg"
          animation={false}
          onHide={this.props.closemodel}
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>Support Users</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col lg={12}>
                  <div>
                    <Form>
                      <Row>
                        <Col lg={6} md={6} sm={12} xs={12}>
                          <Form.Group controlId="fName">
                            <Form.Label>First Name</Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="fName"
                              value={this.state.value.fName}
                              onChange={this.onChange}
                            />
                          </Form.Group>
                        </Col>

                        <Col lg={6} md={6} sm={12} xs={12}>
                          <Form.Group controlId="lName">
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="lName"
                              value={this.state.value.lName}
                              onChange={this.onChange}
                            />
                          </Form.Group>
                        </Col>

                        <Col lg={6} md={6} sm={12} xs={12}>
                          <Form.Group controlId="dsgntn">
                            <Form.Label>Designation</Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="dsgntn"
                              value={this.state.value.dsgntn}
                              onChange={this.onChange}
                            />
                          </Form.Group>
                        </Col>

                        <Col lg={6} md={6} sm={12} xs={12}>
                          <Form.Group controlId="email">
                            <Form.Label>Email ID</Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="email"
                              value={this.state.value.email}
                              onChange={this.onChange}
                            />
                            <div className="errStyle">
                              {this.state.emailError}
                            </div>
                          </Form.Group>
                        </Col>

                        <Col lg={6} md={6} sm={12} xs={12}>
                          <Form.Group controlId="mob">
                            <Form.Label>Mobile Number</Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="mob"
                              value={this.state.value.mob}
                              onChange={this.onChange}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
            <Button type="submit" onClick={this.submit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default EditSupportUsers;
